//
//
//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Inline', component.exports)
}
export default {
	props: {
		gap: {
			type: String,
			default: '0'
		},
		padY: {
			type: String,
			default: '0'
		},
		align: {
			type: String,
			default: 'center',
			validator: function(value) {
				return (
					[
						'baseline',
						'center',
						'flex-end',
						'flex-start',
						'initial',
						'stretch',
						'unset'
					].indexOf(value) !== -1
				);
			}
		}
	}
};
